<template>
    <div v-select-text="value"  style="width: 800px; margin:0 auto; position: relative; border: 3px solid #efefef; padding: 20px;">
        <table width="100%" border="1" cellspacing="0">
            <tbody>
            <tr>
                <th class="id58-p">Амека</th>
                <th class="id58-p">Лос Поситос</th>
                <th class="id58-p">Эль Куис</th>
                <th class="id58-p">Тамасулита</th>
                <th class="id58-p">Тапальпа</th>
                <th class="id58-p"></th>
            </tr>
            <tr>
                <td class="id58-p" align="center">224</td>
                <td class="id58-p" align="center">171</td>
                <td class="id58-p" align="center">273</td>
                <td class="id58-p" align="center">330</td>
                <td class="id58-p" align="center">289</td>
                <td class="id58-p">Сан Хосе Де Грасиа</td>
            </tr>
            <tr>
                <td class="id58-p" align="center">96</td>
                <td class="id58-p" align="center">139</td>
                <td class="id58-p" align="center">32</td>
                <td class="id58-p" align="center">420</td>
                <td class="id58-p" align="center">515</td>
                <td class="id58-p">Идео Нисулиа</td>
            </tr>
            <tr>
                <td class="id58-p" align="center">67</td>
                <td class="id58-p" align="center">366</td>
                <td class="id58-p" align="center">487</td>
                <td class="id58-p" align="center">550</td>
                <td class="id58-p" align="center">95</td>
                <td class="id58-p">Санхе Порто</td>
            </tr>
            <tr>
                <td class="id58-p" align="center">269</td>
                <td class="id58-p" align="center">105</td>
                <td class="id58-p" align="center">49</td>
                <td class="id58-p" align="center">74</td>
                <td class="id58-p" align="center">147</td>
                <td class="id58-p">Мехико</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    import SelectText from '@/directives/select-text.js'

    export default {
        props: {
            value: [Array]
        },
        directives: {
            SelectText
        }
    }
</script>
<style scoped>
    .id58-p {
        padding: 4px;
    }
</style>